export class TechBuyerOrganization {
    countryId: string;
    industryId: string;
    employeeSizeId: string;
    revenueId: string;
    itBudgetId: string;
    labelName: string;
    geoCountry: string;
    geographic: string;
    geoCountryId: string;
    lineOfBusinessId: string;
    jobTitleId: string;
}



// WEBPACK FOOTER //
// ./src/app/feature/main/tech-buyer/shared/models/tech-buyer-organization-model.ts